import React from 'react';

const mediaImages = [
  {
    url: 'images/Screenshot 2026-04-11 at 6.55.58 PM.png',
    company: 'News18',
    link: 'https://hindi.news18.com/news/uttar-pradesh/lucknow-cafe-hons-house-of-no-sugar-italian-mexican-chinese-indian-and-greek-dishes-available-in-restaurant-6346679.html'
  },
  // {
  //   url: 'images/Screenshot 2026-04-11 at 6.55.29 PM.png',
  //   company: 'The Times of India',
  //   link: ''
  // },
  {
    url: 'images/Screenshot 2026-04-11 at 6.56.34 PM.png',
    company: 'Curly Tales',
    link: 'https://curlytales.com/new-restaurants-in-lucknow-to-try-this-month-for-some-nawabi-delights/'
  },
  {
    url: 'images/Screenshot 2026-04-11 at 6.56.17 PM.png',
    company: 'Knocksense',
    link: 'https://www.knocksense.com/lucknow/new-in-lucknow-fosho-is-serving-creamy-gyozas-ramen-and-more-for-a-true-pan-asian-experience/'
  },
  {
    url: 'images/Screenshot 2026-04-11 at 6.56.55 PM.png',
    company: 'Hindustan Times',
    link: 'https://www.hindustantimes.com/cities/lucknow-news/revival-of-lucknow-s-iconic-newal-kishore-press-as-heritage-market-museum-after-20-years-by-kishore-family-scions-101683397905986.html'
  }
];

const Press = () => {
  return (
    <main className="min-h-screen pt-20">
      <section className="bg-cream py-20 md:py-32">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-center text-espresso mb-8">
            Press & Media
          </h1>
          <div className="h-1 w-24 bg-burnt-amber mx-auto mb-12"></div>
          <p className="font-nunito text-center text-espresso/80 text-lg max-w-3xl mx-auto">
          Our work has been featured and appreciated across platforms for its distinctive approach to food, design, and overall experience. Each of our spaces brings its own character, contributing to a growing presence that reflects thoughtful concepts and attention to detail. For press inquiries, collaborations, or features, we’d love to connect and share more.
          </p>
          
          <div className="mt-20 text-center">
          <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
            {mediaImages.map((media, index) => (
              <a
                key={index}
                href={media.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`group relative overflow-hidden rounded-lg shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 cursor-pointer ${
                  index % 4 === 0
                    ? 'bg-grey/10'
                    : index % 4 === 1
                    ? 'bg-lightBlue/10'
                    : index % 4 === 2
                    ? 'bg-darkBlue/10'
                    : 'bg-grey/20'
                }`}
              >
                <div className="p-4">
                  <img
                    src={media.url}
                    alt={`${media.company} media coverage`}
                    className="w-full h-auto object-cover rounded"
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-white text-sm font-semibold">{media.company}</p>
                  <p className="text-white text-xs mt-1">Read Article →</p>
                </div>
              </a>
            ))}
          </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Press;

